
module.exports = Object.freeze({
    MODAL_BODY_TYPES : {
        USER_DETAIL : "USER_DETAIL",
        LEAD_ADD_NEW : "LEAD_ADD_NEW",
        CONFIRMATION : "CONFIRMATION",
        REUSABLE_MODAL : "REUSABLE_MODAL",
        SUBSCRIPTION_PLAN_DETAILS : "SUBSCRIPTION_PLAN_DETAILS",
        EDIT_SUBSCRIPTION_PLAN : "EDIT_SUBSCRIPTION_PLAN",
        CREATE_SUBSCRIPTION_PLAN : "CREATE_SUBSCRIPTION_PLAN",
        DELETE_SUBSCRIPTION_PLAN_CONFIRMATION : "DELETE_SUBSCRIPTION_PLAN_CONFIRMATION",
        COURSE_DETAILS : "COURSE_DETAILS",
        EDIT_COURSE : "EDIT_COURSE",
        CREATE_COURSE : "CREATE_COURSE",
        DELETE_COURSE_CONFIRMATION : "DELETE_COURSE_CONFIRMATION",
        ADD_EXISTING_LESSON_TO_COURSE : "ADD_EXISTING_LESSON_TO_COURSE",
        CREATE_LESSON_IN_COURSE : "CREATE_LESSON_IN_COURSE",
        EDIT_LESSON_IN_COURSE : "EDIT_LESSON_IN_COURSE",
        REMOVE_LESSON_FROM_COURSE : "REMOVE_LESSON_FROM_COURSE",
        CREATE_LESSON : "CREATE_LESSON",
        EDIT_LESSON : "EDIT_LESSON",
        DELETE_LESSON_CONFIRMATION : "DELETE_LESSON_CONFIRMATION",
        CREATE_CATEGORY : "CREATE_CATEGORY",
        EDIT_CATEGORY : "EDIT_CATEGORY",
        DELETE_CATEGORY_CONFIRMATION : "DELETE_CATEGORY_CONFIRMATION",
        CREATE_AUTHOR : "CREATE_AUTHOR",
        EDIT_AUTHOR : "EDIT_AUTHOR",
        DELETE_AUTHOR_CONFIRMATION : "DELETE_AUTHOR_CONFIRMATION",
        CREATE_EVENT : "CREATE_EVENT",
        EDIT_EVENT : "EDIT_EVENT",
        DELETE_EVENT_CONFIRMATION : "DELETE_EVENT_CONFIRMATION",
        CREATE_QUIZ : "CREATE_QUIZ",
        EDIT_QUIZ : "EDIT_QUIZ",
        VIEW_QUIZZES : "VIEW_QUIZZES",
        DELETE_QUIZ_CONFIRMATION : "DELETE_QUIZ_CONFIRMATION",
        CREATE_QUIZ_QUESTION : "CREATE_QUIZ_QUESTION",
        EDIT_QUIZ_QUESTION : "EDIT_QUIZ_QUESTION",
        DELETE_QUIZ_QUESTION_CONFIRMATION : "DELETE_QUIZ_QUESTION_CONFIRMATION",
        CREATE_ASSOCIATION : "CREATE_ASSOCIATION",
        EDIT_ASSOCIATION : "EDIT_ASSOCIATION",
        DELETE_ASSOCIATION_CONFIRMATION : "DELETE_ASSOCIATION_CONFIRMATION",
        ISSUE_VOUCHER : "ISSUE_VOUCHER",
        EDIT_VOUCHER : "EDIT_VOUCHER",
        SHARE_VOUCHER : "SHARE_VOUCHER",
        SEND_ONBOARDING_EMAIL : "SEND_ONBOARDING_EMAIL",
        DEFAULT : "",
    },

    RIGHT_DRAWER_TYPES : {
        NOTIFICATION : "NOTIFICATION",
        CALENDAR_EVENTS : "CALENDAR_EVENTS",
    },

    CONFIRMATION_MODAL_CLOSE_TYPES : {
        LEAD_DELETE : "LEAD_DELETE",
    },
});
